import React from 'react';
import { Box } from '@chakra-ui/react';
import { ImStarEmpty, ImStarHalf, ImStarFull } from 'react-icons/im';

export function Rating({ value, total, color }) {
  const starRating = (value / 10) * 5;
  const fullStars = Math.floor(starRating);
  const halfStars = Math.round(starRating - fullStars);
  const emptyStars = 5 - fullStars - halfStars;

  const stars = [];

  for (let i = 0; i < fullStars; i++) {
    stars.push(<ImStarFull key={`full-${i}`} />);
  }

  for (let i = 0; i < halfStars; i++) {
    stars.push(<ImStarHalf key={`half-${i}`} />);
  }

  for (let i = 0; i < emptyStars; i++) {
    stars.push(<ImStarEmpty key={`empty-${i}`} />);
  }

  return (
    <Box
      display="inline-flex"
      alignItems="center"
      fontSize="12px"
      color={color || 'blue.300'}
    >
      {stars}{' '}
      <Box as="span" pl="2">
        / {total}
      </Box>
    </Box>
  );
}
